<template>
  <v-container class="text-center">
    <h1>Forgot your password?</h1>
    <div class="mb-10">
      Please enter the email address associated with your account and We will email you a link to reset your password.
    </div>

    <v-form
      ref="form"
      lazy-validation
      @submit="submit"
    >
      <v-text-field
        label="E-mail"
        type="email"
        required
        outlined
        :disabled="loading || disableEmail"
        v-model="email"
        :error-messages="emailErrors"
      ></v-text-field>

      <div class="mb-5 otp-box">
        <v-otp-input
          length="6"
          type="number"
          v-model="otp"
          :disabled="loading"
          :error-messages="otpErrors"
        ></v-otp-input>
      </div>

      <v-text-field
        v-model="pass"
        :append-icon="showPass ? 'mdi-eye' : 'mdi-eye-off'"
        :type="showPass ? 'text' : 'password'"
        label="New password"
        required
        outlined
        :disabled="loading"
        @click:append="showPass = !showPass"
        :error-messages="passErrors"
      ></v-text-field>

      <v-text-field
        v-model="pass2"
        :append-icon="showPass ? 'mdi-eye' : 'mdi-eye-off'"
        :type="showPass ? 'text' : 'password'"
        label="Confirm password"
        required
        outlined
        :disabled="loading"
        @click:append="showPass = !showPass"
        :error-messages="pass2Errors"
      ></v-text-field>

      <v-btn color="primary"
             class="w-100 sh-green mb-2"
             :loading="loading"
             x-large
             @click="submit">
        Reset password
      </v-btn>

      <v-btn color="primary" x-large text class="w-100" @click="goBack">
        Back
      </v-btn>
    </v-form>
  </v-container>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required, email, minLength, maxLength } from 'vuelidate/lib/validators'
import { mapActions } from 'vuex'

export default {
  name: 'ResetPassword',

  mixins: [validationMixin],
  validations: {
    email: { required, email },
    otp: { required, minLength: minLength(6), maxLength: maxLength(6) },
    pass: { required, minLength: minLength(6), maxLength: maxLength(16) },
    pass2: { required, minLength: minLength(6), maxLength: maxLength(16) }
  },
  computed: {
    emailErrors () {
      const errors = []
      if (!this.$v.email.$dirty) return errors
      !this.$v.email.email && errors.push('Must be valid e-mail')
      !this.$v.email.required && errors.push('E-mail is required')
      this.invalidEmail && errors.push('Can\'t reset password')
      return errors
    },
    otpErrors () {
      const errors = []
      if (!this.$v.otp.$dirty) return errors
      !this.$v.otp.minLength && errors.push('Code must be 6 characters long')
      !this.$v.otp.maxLength && errors.push('Code must be 6 characters long')
      !this.$v.otp.required && errors.push('Code is required')
      this.invalidOTP && errors.push('Invalid code')
      return errors
    },
    passErrors () {
      const errors = []
      if (!this.$v.pass.$dirty) return errors
      !this.$v.pass.minLength && errors.push('Password must be more than 6 characters long')
      !this.$v.pass.maxLength && errors.push('Password must be less than 16 characters long')
      !this.$v.pass.required && errors.push('Password is required')
      return errors
    },
    pass2Errors () {
      const errors = []
      if (!this.$v.pass.$dirty) return errors
      !this.$v.pass.required && errors.push('Password is required')
      this.pass !== this.pass2 && errors.push('Passwords mismatch')
      return errors
    }
  },

  data: () => ({
    loading: false,
    otp: '',
    email: '',
    pass: '',
    pass2: '',
    showPass: false,
    invalidEmail: false,
    disableEmail: false
  }),
  created () {
    this.email = this.$store.getters['auth/regEmail']
    if (this.email !== '') {
      this.disableEmail = true
    }
  },
  methods: {
    ...mapActions({
      signIn: 'auth/SIGNIN'
    }),
    goBack () {
      this.$router.push({ name: 'auth.signin' })
    },
    submit (e) {
      e.preventDefault()

      this.invalidEmail = false
      this.loading = true
      this.$v.$touch()
      if (!this.$v.$invalid && this.pass === this.pass2) {
        this.$api.auth.resetPasswordComplete({
          email: this.email,
          code: this.otp,
          password: this.pass
        }).then(({ data }) => {
          this.signIn(data).then(() => {
            this.$router.push({ name: 'cpanel.dashboard' })
          })
        }).catch(() => {
          this.invalidEmail = true
        }).finally(() => {
          this.loading = false
        })
      } else {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped lang="scss">
.otp-box {
  padding: 0 50px;
}
</style>
